module.exports = __webpack_public_path__ + "img/pisco_sour.4b508bc4.jpg";